import React, { createContext, useState, useEffect } from 'react';
import { PaymentSource } from '../../constants';
import { useOrderDetails } from '../OrderDetails';

export const OrderDetailsPaymentSourceContext = createContext<{
  paymentSource: PaymentSource;
  setPaymentSource: (paymentSource: PaymentSource) => void;
}>({
  paymentSource: PaymentSource.Adyen,
  setPaymentSource: () => {
    return;
  }
});

export const OrderDetailsPaymentSourceProvider: React.FC = ({ children }) => {
  const { orderSummary } = useOrderDetails();
  // store the source in state to be able to switch to Adyen even when there are no Adyen cards
  // this violates single source of truth, but there's no better way to do it with the current mojo api
  const [paymentSource, setPaymentSource] = useState(
    orderSummary?.attributes.paymentMethod.source ?? PaymentSource.Adyen
  );

  // if the selected payment method is changed to another source, update the source in the state
  useEffect(() => {
    const source = orderSummary?.attributes.paymentMethod.source ?? PaymentSource.Adyen;
    if (source !== paymentSource) setPaymentSource(source);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderSummary]);

  return (
    <OrderDetailsPaymentSourceContext.Provider value={{ paymentSource, setPaymentSource }}>
      {children}
    </OrderDetailsPaymentSourceContext.Provider>
  );
};
